import axios from 'axios';

export const typeWorkApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/type-work/parent`,
    headers: {
        'Content-Type': 'application/json'
    }
})